import * as Sentry from '@sentry/react';

// Prefer VITE_SENTRY_DSN from Vercel env vars, fall back to the
// hardcoded public DSN when the env var isn't inlined at build time
// (e.g. when it's marked Sensitive in Vercel, which prevents inlining
// and causes Vite's dead-code eliminator to tree-shake Sentry.init).
// Keeping the literal fallback ensures `dsn` is always truthy, so the
// init block is preserved in the bundle either way.
const SENTRY_DSN =
  import.meta.env.VITE_SENTRY_DSN ||
  'https://c68a94862b0ba89c70ff54a7fbe08bb4@o4511267654664192.ingest.us.sentry.io/4511267999121408';

try {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE || 'production',
    tracesSampleRate: 0.1,
    beforeSend(event) {
      // Drop auth / forbidden HTTP errors — expected client behaviour, not bugs
      const msg = event.exception?.values?.[0]?.value ?? '';
      if (/Request failed with status code (401|403)/.test(msg)) return null;
      // Scrub cookies from all events
      if (event.request?.cookies) delete event.request.cookies;
      return event;
    },
  });
} catch (err) {
   
  console.warn('[sentry] init failed:', err);
}

/** Wrap the ErrorBoundary render with Sentry reporting. */
export function reportError(err: unknown, context?: Record<string, unknown>) {
  try {
    Sentry.captureException(err, { extra: context });
  } catch {
    /* noop */
  }
}

/** Attach the logged-in user to Sentry scope so events are de-anon. */
export function identifyUser(id: string | null, email?: string, tenantId?: string) {
  if (id) {
    Sentry.setUser({ id, email });
    if (tenantId) Sentry.setTag('tenantId', tenantId);
  } else {
    Sentry.setUser(null);
  }
}
